import { render, staticRenderFns } from "./productInspection.vue?vue&type=template&id=0cf7b11d&scoped=true"
import script from "./productInspection.vue?vue&type=script&lang=js"
export * from "./productInspection.vue?vue&type=script&lang=js"
import style0 from "./productInspection.vue?vue&type=style&index=0&id=0cf7b11d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7b11d",
  null
  
)

export default component.exports